module.exports = __webpack_public_path__ + "static/media/7.80af77c5.jpg";